
import {
  TBaseTypographyProps,
  TTypographyAlign,
  TTypographyAlignSubsetProp,
  TTypographyColor,
  TTypographyTag,
  TTypographyWhitespace,
  BASE_TYPOGRAPHY_DEFAULTS,
} from "@/ui/components/typography/typography.config";
import { DefinedDefaults, SubsetKeys, subsetOf } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const AVAILABLE_TEXT_TITLE_TAGS = subsetOf<TTypographyTag>()([ "h1", "h2", "h3", "h4", "h5", "h6", "div" ]);

export const AVAILABLE_TEXT_TITLE_COLORS =
  subsetOf<TTypographyColor>()([ "default" ]);

export const AVAILABLE_TEXT_TITLE_ALIGNMENTS =
  subsetOf<TTypographyAlign>()([ "left", "center" ]);

export const AVAILABLE_TEXT_TITLE_WHITESPACE =
  subsetOf<TTypographyWhitespace>()([ "normal", "balance" ]);

export const BASE_TEXT_TITLE_SIZE_CLASS_MAP = {
  1: "text-sys-6xl leading-sys-0-9",
  2: "text-sys-5xl leading-sys-0-95",
  3: "text-sys-4xl leading-sys-1-15",
} as const;

export const RESPONSIVE_TEXT_TITLE_SIZE_CLASS_MAP = {
  1: `${BASE_TEXT_TITLE_SIZE_CLASS_MAP[1]} xl:text-sys-7xl`,
  2: `${BASE_TEXT_TITLE_SIZE_CLASS_MAP[2]} xl:text-sys-6xl`,
  3: `${BASE_TEXT_TITLE_SIZE_CLASS_MAP[3]} xl:text-sys-5xl`,
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TTextTitleTag = SubsetKeys<typeof AVAILABLE_TEXT_TITLE_TAGS>;
export type TTextTitleColor = SubsetKeys<typeof AVAILABLE_TEXT_TITLE_COLORS>;
export type TTextTitleAlign = SubsetKeys<typeof AVAILABLE_TEXT_TITLE_ALIGNMENTS>;
export type TTextTitleWhitespace = SubsetKeys<typeof AVAILABLE_TEXT_TITLE_WHITESPACE>;
export type TTextTitleSize = keyof typeof BASE_TEXT_TITLE_SIZE_CLASS_MAP;

export type TTextTitleProps = TBaseTypographyProps & {
  color?: TTextTitleColor;
  align?: TTypographyAlignSubsetProp<TTextTitleAlign>;
  tag?: TTextTitleTag;
  whitespace?: TTextTitleWhitespace;
  size?: TTextTitleSize;
};

type TTextTitleDefaultProps = DefinedDefaults<
  TTextTitleProps,
  "color" | "align" | "tag" | "whitespace" | "size"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const TEXT_TITLE_DEFAULTS = {
  ...BASE_TYPOGRAPHY_DEFAULTS,
  color: "default",
  align: "left",
  tag: "h2",
  whitespace: "normal",
  size: 1,
} satisfies TTextTitleDefaultProps;
